import React from 'react'
import { useIsSmallScreen } from './useIsSmallScreen'
import { pushIntercomModal, popIntercomModal } from '@/common/utils/intercom'

interface IntercomVisibilityControllerProps {
    open: boolean
}

/**
 * Controls Intercom widget visibility based on dialog open state and screen size.
 * - Hides Intercom widget when dialog is open and on small screens.
 * - Restores each element's original inline `display` when closing.
 */
const IntercomVisibilityController: React.FC<IntercomVisibilityControllerProps> = ({ open }) => {
    const isSmallScreen = useIsSmallScreen(768)

    // Use a ref-counted Intercom API so multiple dialogs/popovers don't stomp each other.
    const pushedRef = React.useRef(false)
    React.useEffect(() => {
        if (typeof document === 'undefined') return

        const shouldHide = open && isSmallScreen
        if (shouldHide && !pushedRef.current) {
            pushIntercomModal()
            pushedRef.current = true
        }
        if (!shouldHide && pushedRef.current) {
            popIntercomModal()
            pushedRef.current = false
        }

        return () => {
            if (pushedRef.current) {
                popIntercomModal()
                pushedRef.current = false
            }
        }
    }, [open, isSmallScreen])

    return null
}

export default IntercomVisibilityController
